module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcUlEQVR42u3awQkAIBADwavZRi0pCmIVmYOFvOd9k2SaGwAAAAAAAAAAAAAAygFm7TQFAAAAAAAAAAAAAAAAAG/c2RQAAAAAAAAAAAAAAAAA/NoOAAAAAAAAAAAAAAAAAAB4lAQAAAAAAAAAAAAAoKsDHT3Fa18a+8UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Estonia.png
// module id = wzUM
// module chunks = 0 62 63